import * as dotProp from 'dot-prop-immutable';

import { createReducer } from '@topconagriculture/frontend-utils';

import {
  createLotMarketType,
  deleteLotMarketType,
  getLotMarketTypes,
  updateLotMarketType,
} from './lotMarketTypes.actions';
import { LotMarketType } from './lotMarketTypes.types';

export type LotMarketTypesState = LotMarketType[];

const initialState: LotMarketTypesState = [];

const lotMarketTypesReducer = createReducer(initialState, {
  [getLotMarketTypes.done.type]: (_state: LotMarketTypesState, action: ReturnType<typeof getLotMarketTypes.done>) => {
    return action.payload.result;
  },
  [createLotMarketType.done.type]: (
    state: LotMarketTypesState,
    action: ReturnType<typeof createLotMarketType.done>,
  ) => {
    return [...state, action.payload.result];
  },
  [updateLotMarketType.done.type]: (
    state: LotMarketTypesState,
    action: ReturnType<typeof updateLotMarketType.done>,
  ) => {
    const updatedLotType = action.payload.result;
    const indexFound = state.findIndex((lotType) => lotType.id === updatedLotType.id);
    return dotProp.set(state, indexFound, updatedLotType);
  },
  [deleteLotMarketType.done.type]: (
    state: LotMarketTypesState,
    action: ReturnType<typeof deleteLotMarketType.done>,
  ) => {
    const deletedLotTypeId = action.payload.result;
    const indexFound = state.findIndex((lotType) => lotType.id === deletedLotTypeId);
    return dotProp.delete(state, indexFound);
  },
});

export default lotMarketTypesReducer;
